import StoreIcon from "@redotech/redo-icons/building-01.svg";
import {
  riskLabels,
  ShopifyRiskAssessmentResult,
} from "@redotech/redo-model/fulfillments/shopify-fulfillment-schemas";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const FraudRiskFilter = (): ArrayStringTableFilter => ({
  type: AdvancedFilterType.ARRAY_TO_STRING,
  itemLabel: "risk",
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.ALL_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  data: {
    name: "fraudRisk",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  Icon: StoreIcon,
  values: Object.values(ShopifyRiskAssessmentResult),
  dbSearch: false,
  display: (item: string) => {
    return riskLabels[item as ShopifyRiskAssessmentResult];
  },
  displayName: "Fraud risk",
});
